var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"questionnaires-layout"},[_c('AppBar',{attrs:{"logo":_vm.organization.logo,"title":_vm.pageTitle}}),_c('div',{staticClass:"questionnaires-content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }